import React from 'react';
import { TICKET_PRIORITY } from '../../services/supportService';

const TicketPriorityBadge = ({ priority }) => {
  const getPriorityStyle = () => {
    switch (priority) {
      case TICKET_PRIORITY.LOW:
        return 'bg-info/20 text-info border border-info/30';
      case TICKET_PRIORITY.MEDIUM:
        return 'bg-success/20 text-success border border-success/30';
      case TICKET_PRIORITY.HIGH:
        return 'bg-warning/20 text-warning border border-warning/30';
      case TICKET_PRIORITY.URGENT:
        return 'bg-error/20 text-error border border-error/30';
      default:
        return 'bg-base-200 text-base-content/60 border border-base-200';
    }
  };

  const getPriorityIcon = () => {
    switch (priority) {
      case TICKET_PRIORITY.LOW:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path d="M1 10a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 011 10zM11 5.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM1.75 15.75A.75.75 0 011 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM11 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 0111 15z" />
          </svg>
        );
      case TICKET_PRIORITY.MEDIUM:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path d="M1 10a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 011 10zM11 5.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM1.75 15.75A.75.75 0 011 15a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM11 15.75a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75z" />
          </svg>
        );
      case TICKET_PRIORITY.HIGH:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path fillRule="evenodd" d="M5.5 17a4.5 4.5 0 01-1.44-8.765 4.5 4.5 0 018.302-3.046 3.5 3.5 0 014.504 4.272A4 4 0 0115 17H5.5zm3.75-2.75a.75.75 0 001.5 0V9.66l1.95 2.1a.75.75 0 101.1-1.02l-3.25-3.5a.75.75 0 00-1.1 0l-3.25 3.5a.75.75 0 101.1 1.02l1.95-2.1v4.59z" clipRule="evenodd" />
          </svg>
        );
      case TICKET_PRIORITY.URGENT:
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-3 h-3 mr-1">
            <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
          </svg>
        );
      default:
        return null;
    }
  };

  const getPriorityLabel = () => {
    switch (priority) {
      case TICKET_PRIORITY.LOW:
        return 'Faible';
      case TICKET_PRIORITY.MEDIUM:
        return 'Moyenne';
      case TICKET_PRIORITY.HIGH:
        return 'Haute';
      case TICKET_PRIORITY.URGENT:
        return 'Urgente';
      default:
        return priority || 'Inconnue';
    }
  };

  return (
    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getPriorityStyle()}`}>
      {getPriorityIcon()}
      {getPriorityLabel()}
    </span>
  );
};

export default TicketPriorityBadge;